module.exports = __webpack_public_path__ + "bb6b6efa37da8ad68f32d8c753ee8245.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/banana.png
// module id = 2363
// module chunks = 0